import { Landmark } from 'lucide-react'
import { toast } from 'sonner'

import { Button } from '@/components/ui/button'
import { apiErrorDetail } from '@/lib/apiError'
import { type SalesLead, useCheckFmcsa } from '@/models/salesLead'

/** Reads the lead's FMCSA registration now; offered until its buyer type has an FMCSA answer. */
export function CheckFmcsaButton({ lead }: { lead: SalesLead }) {
  const checkFmcsaMutation = useCheckFmcsa()
  if (!lead.dotNumber || lead.fmcsaCheckedAt) return null

  function handleClick() {
    checkFmcsaMutation.mutate(lead.id, {
      onError: (error) => toast.error(apiErrorDetail(error, 'Couldn’t check FMCSA. Try again.')),
    })
  }

  return (
    <Button
      variant="outline"
      onClick={handleClick}
      loading={checkFmcsaMutation.isPending ? 'Checking FMCSA…' : undefined}
      className="w-full justify-start"
    >
      <Landmark className="mr-2 size-4" />
      Check FMCSA
    </Button>
  )
}
